import React, { useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import SearchCompany from './SearchCompany';
import { getId } from '../util/ID'


export default function AddLoveDialog(props) {
    const [open, setOpen] = React.useState(false);
    const [tp, setTP] = React.useState(0);
    const [sid, setSID] = React.useState(null);
    const [tags, setTags] = React.useState([])  
    const [id, setID] = React.useState("0");

    useEffect(() => {
        if(tags != null && tags.length > 0) setID(tags[0].id)//setID("0")
    }, [tags]);


    const handleClose = () => {
        setOpen(false);
        if (props.close != null) props.close(false)
        // if(props.refresh != null) props.refresh()
    };

    const handleOKClose = () => {
        setOpen(false);
        clickLove()
        if (props.close != null) props.close(false)
    };


    const clickLove = () => {
        let froms = ""
        if(id != "") froms = id

        if(sid != null && froms != "") {
            let param = {
                sn: getId(),
                sid: sid,
                tp: froms,
                froms: froms
            }
    
            if(localStorage.getItem("lic") != null) {
                param['lic'] = localStorage.getItem("lic")
            }
    
            fetch("/ocb/v1/stock2/cb/clicklove", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(param)
            })
                .then(res => res.json())
                .then(
                    result => {
                        if (result != null && result.status === 0) {
                            if (props.refresh != null) props.refresh()
                        }
                    }
                );
        }
    }

    useEffect(() => {
        if (props.open) setOpen(true)
        else setOpen(false)
    }, [props.open]);


    const fectchTags = () => {
        let u = "/ocb/v1/stock3/cb/tag"
        
        fetch(u, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
        })
            .then(res => res.json())
            .then(
                result => {
                    if (result != null) {
                        setTags(result)
                        // if(result.length > 0) setID(result[0].id)
                    }
                }
            );
    }



    useEffect(() => {
        fectchTags()
    }, []);

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={open}
                onClose={handleClose}
            >
                <DialogTitle id="alert-dialog-title">
                    {"新增自選"}
                </DialogTitle>
                <DialogContent>
                    {/* <Box sx={{ p: 2 }}>
                        
                    </Box> */}

                    <Stack spacing={3} direction="column" sx={{ p: 2 }}>
                    <SearchCompany setSID={setSID}/>

                        <FormControl fullWidth >
                            <InputLabel id="demo-simple-select-label">主要策略</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={id}
                                label="主要策略"
                                onChange={e => setID(e.target.value)}
                            >
                                {/* <MenuItem key={"none"} value="">無</MenuItem> */}
                                {tags !=null && tags.map(t => {
                                    return <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                                })}
                            </Select>
                        </FormControl>

                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>取消</Button>
                    <Button  onClick={handleOKClose} autoFocus>
                        確定
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
